/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_CodeInputs */

const vi_order_code = /** @type {(inputs: Order_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn`)
};

/**

* @param {Order_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_code = /** @type {((inputs?: Order_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_code(inputs)
});